var initMiewGrid = function () {
    if ($('.miew-grid').length > 0) {
        $('.miew-grid').isotope({
            itemSelector: '.item',
            percentPosition: true,
            sortBy: 'original-order',
            masonry: {
                columnWidth: '.sizer',
                gutter: 0
            }
        });
    }
}
